export const dataGridHeight = "80vh";
export const dataGridHeightExplore = "60vh";
export const dataGridRowHeight = 25;
export const dataGridHeaderFooterHeight = 30;
export const dataGridPageSizeOption  = [20,50,100]
export const dataGridPageSize = 100
export const formGap = "10px"
export const menuHeight = 35

